export default __webpack_public_path__ + "static/media/otp.fb05df88.png";